import { useTranslation } from 'react-i18next'
import { css } from 'twind/css'
import { useTw } from '../Styles'

const bot_styles = css`
  color: #fff;
  font-size: 12px;
  margin-left: 6px;
  line-height: 16px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  background: #4c4859;
`

export function BotTag() {
  const tw = useTw()
  const [t] = useTranslation('common')
  return <span className={tw(bot_styles)}>{t('bot.tag')}</span>
}
